var staticDayTime = 86400000

module.exports = staticDayTime
